module.exports = __webpack_public_path__ + "static/media/ufo_bird3.8ce923ec.svg";